/**
 * @param e KeyboardEvent
 */
export const isBackspaceKeyCode = (e) => {
  return e.keyCode === 8
}

/**
 * @param e KeyboardEvent
 */
export const isDeleteKeyCode = (e) => {
  return e.keyCode === 46
}

/**
 * @param e KeyboardEvent
 */
export const isLengthKeyCode = (e) => {
  return isNumericKey(e) || isCommaKey(e) || isPeriodKey(e) || isSpace(e) || isSlash(e) || e.key === "'" || e.key === "\""
}

/**
 * @param e KeyboardEvent
 */
export const isNumericKey = (e) => {
  return (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)
}

/**
 *  is ","
 * @param e KeyboardEvent
 */
export const isCommaKey = (e) => {
  return e.keyCode === 188
}

/**
 *  is "."
 * @param e KeyboardEvent
 */
export const isPeriodKey = (e) => {
  return e.keyCode === 190
}

/**
 *  is " "
 * @param e KeyboardEvent
 */
export const isSpace = (e) => {
  return e.keyCode === 32
}

/**
 *  is "/"
 * @param e KeyboardEvent
 */
export const isSlash = (e) => {
  return e.keyCode === 191
}

/**
 * Undo the current drawing step, including on non-Latin keyboard layouts.
 * @param e
 * @return {*|boolean}
 */
export const isUndoKeyCode = (e) => {
  const target = e.target;
  if (target && (target.isContentEditable || target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) {
    return false;
  }
  return Boolean(e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey
    && (e.code === 'KeyZ' || e.key === 'z' || e.key === 'Z' || e.keyCode === 90);
};
